import { render, staticRenderFns } from "./base-currency-field.vue?vue&type=template&id=043ea75a"
import script from "./base-currency-field.ts?vue&type=script&lang=ts&external"
export * from "./base-currency-field.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('043ea75a')) {
      api.createRecord('043ea75a', component.options)
    } else {
      api.reload('043ea75a', component.options)
    }
    module.hot.accept("./base-currency-field.vue?vue&type=template&id=043ea75a", function () {
      api.rerender('043ea75a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vuetify/CurrencyField/base-currency-field.vue"
export default component.exports